// src/admin/components/dashboard/SalesSummaryCard.tsx
import React from 'react';

interface SalesSummaryCardProps {
  title: string;
  value: string;
  percentage: string;
  comparisonText: string;
  changeType: 'positive' | 'negative';
  icon: string; // Using string for now, could be ReactNode for Lucide icon
  progressBarValue?: number; // For Total Sales card
}

const SalesSummaryCard: React.FC<SalesSummaryCardProps> = ({
  title,
  value,
  percentage,
  comparisonText,
  changeType,
  icon,
  progressBarValue,
}) => {
  const percentageColor = changeType === 'positive' ? 'text-green-500' : 'text-red-500';
  const iconBgColor =
    title === "Total Sales" ? "bg-blue-100" :
    title === "Total Orders" ? "bg-purple-100" :
    title === "Order Complete" ? "bg-green-100" :
    "bg-red-100"; // For Cancel Order

  return (
    <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-100 flex flex-col justify-between h-full">
      <div className="flex items-center justify-between mb-3">
        <div className={`rounded-full p-2 ${iconBgColor}`}>
          <span className="text-xl">{icon}</span> {/* Simple icon display */}
        </div>
        <span className="text-xs text-gray-500">{title}</span>
      </div>
      <h3 className="text-3xl font-bold text-gray-900 mb-2">{value}</h3>
      <div className="flex items-center text-sm mb-4">
        <span className={`font-semibold mr-2 ${percentageColor}`}>{percentage}</span>
        <span className="text-gray-500">{comparisonText}</span>
      </div>
      {progressBarValue !== undefined && (
        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
          <div
            className="bg-yellow-500 h-2.5 rounded-full"
            style={{ width: `${progressBarValue}%` }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default SalesSummaryCard;